import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import cleverooLogo from '../../assets/cleveroo.svg';
import './Try.css';

/**
 * Public, no-signup entry point (ROO-142): /try
 *
 * Lets an anonymous visitor pick Maths or English, then routes to the
 * 3-question sample quiz at /try/:subject. No auth required — this is the
 * top of the acquisition funnel, so it must never redirect to login.
 */
const SUBJECTS: {
  slug: string;
  label: string;
  blurb: string;
  tone: 'orange' | 'green';
  icon: React.ReactNode;
}[] = [
  {
    slug: 'maths',
    label: 'Maths',
    blurb: 'Numbers, shapes & problem solving',
    tone: 'orange',
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="3" width="16" height="18" rx="2" />
        <path d="M8 7h8M8 11h2m4 0h2M8 15h2m4 0h2" />
      </svg>
    ),
  },
  {
    slug: 'english',
    label: 'English',
    blurb: 'Reading, grammar & vocabulary',
    tone: 'green',
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 19V7a2 2 0 0 1 2-2h11l4 4v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <path d="M8 11h8m-8 4h6" />
      </svg>
    ),
  },
];

const TrySubjectPicker: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="cvr-portal try-shell">
      <header className="try-header">
        <Link to="/" className="try-header__brand">
          <img src={cleverooLogo} alt="Cleveroo" />
          <span>cleveroo</span>
        </Link>
      </header>

      <main className="try-picker">
        <div className="try-picker__kicker">Free · No account needed</div>
        <h1 className="try-picker__title">Try 3 real questions</h1>
        <p className="try-picker__sub">
          See exactly what your child will practise on Cleveroo — pick a subject
          and we'll pull 3 real questions for you to try right now.
        </p>

        <div className="try-picker__grid">
          {SUBJECTS.map((s) => (
            <button
              key={s.slug}
              type="button"
              className={`try-card try-card--${s.tone}`}
              onClick={() => navigate(`/try/${s.slug}`)}
            >
              <span className="try-card__icon">{s.icon}</span>
              <span className="try-card__label">{s.label}</span>
              <span className="try-card__blurb">{s.blurb}</span>
              <span className="try-card__cta">Start ›</span>
            </button>
          ))}
        </div>

        <p className="try-picker__foot">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </main>
    </div>
  );
};

export default TrySubjectPicker;
